<template>
  <div>
    <div class="instruction_title text-left para-mrgn-20" v-translate:dynamic_string="{ key: `${translationKeyInitial}_formattedBody`, val: lang, html: question.formattedBody }" v-html="question.formattedBody" />
    <div v-if="componentData.allowMultiple" class="mt-10 mb-20" v-translate:label_select_all_that_apply="lang">SELECT ALL THAT APPLY</div>
    <div v-if="getImage">
      <img class="multiple-choice-img-size" width="100%" :src="getImage" />
    </div>
    <div>
      <b-form-group class="mb-5" @click.once="$emit('onClick', question)" v-if="componentData.subType === 'Single'">
        <b-form-radio-group v-model="question.optionsIds[0]" stacked :disabled="isFieldDisabled" v-on:change="onAnswerChange($event)">
          <b-form-radio v-for="option in componentData.options" :key="option.id" :value="option.id" class="light custom_radio">
            <div class="ap-thread-alert-message-preview p-0 col-md-12">
              <span
                v-translate:dynamic_string="{
                  key: widget.getDynamicStringKey(translationKeyInitial, option),
                  val: lang,
                  optionId: option.id,
                  html: option.displayText ? option.displayText : option.body ? option.body : option.label
                }"
                v-html="option.displayText ? option.displayText : option.body ? option.body : option.label"
              ></span>
              <AlertMessage v-if="componentData.colorCodeEnabled && componentData.optionsIds[0] === option.id" :message="option.colorCoding && option.colorCoding.warningMessage" :backgroundColor="option.colorCoding && option.colorCoding.color" />
            </div>
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <b-form-group class="mb-5" v-if="componentData.subType === 'Multi'">
        <b-form-checkbox-group v-model="question.optionsIds" stacked :disabled="isFieldDisabled" v-on:change="onAnswerChange($event)">
          <b-form-checkbox v-for="option in componentData.options" :key="option.id" :value="option.id" class="light">
            <div class="ap-thread-alert-message-preview p-0 col-md-12">
              <span
                v-translate:dynamic_string="{
                  key: widget.getDynamicStringKey(translationKeyInitial, option),
                  val: lang,
                  optionId: option.id,
                  html: option.displayText ? option.displayText : option.body ? option.body : option.label
                }"
                v-html="option.displayText ? option.displayText : option.body ? option.body : option.label"
              ></span>
              <div
                :style="{
                  marginBottom: componentData.colorCodeEnabled && option.colorCoding && option.colorCoding.color ? '10px' : ''
                }"
                v-for="(id, index) in componentData.optionsIds"
                :key="index"
              >
                <div v-if="componentData.colorCodeEnabled && id === option.id">
                  <AlertMessage :message="option.colorCoding && option.colorCoding.warningMessage" :backgroundColor="option.colorCoding && option.colorCoding.color" />
                </div>
              </div>
            </div>
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <span class="text-danger pl-5 fw-bold pt-10" v-if="hasFieldError">{{ fieldErrorText }}</span>
    </div>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";
import { Widget } from "@/components/services/participant-service";
export default {
  name: "multiple-choice",
  mixins: [langTranslate],
  data() {
    return {
      widget: new Widget(),
      hasFieldError: false,
      fieldErrorText: "",
      scoresMap: {}
    };
  },
  mounted(){
    this.$root.$on("questionSkipped", (notifyObj) => {
      if(!!notifyObj && notifyObj.identifier === this.question.identifier && notifyObj.skipped){
        this.clearAnswer();
      }
    });
    this.insertOtherOption();
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  computed: {
    componentData() {
      this.updateQuestionIds();
      return this.question.constraints;
    },
    getImage() {
      return this.question && this.question.bodyImages && this.question.bodyImages[0].imageUrl;
    }
  },
  methods: {
    updateQuestionIds() {
      this.question.optionsIds = this.question.optionsIds ? this.question.optionsIds : [];
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.$emit("onAnswerChange", this.question);
      });
    },
    clearAnswer() {
      this.question.answer = undefined;
      this.question.optionsIds = [];
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.$emit("getQuestionScores");
      this.$emit("onClearAnswer", this.question);
    },
    calculateScoresMap() {
      if (this.componentData.options) {
        this.componentData.options.forEach(option => {
          this.scoresMap[option.id] = option.score || 0;
        });
      }
    },
    insertOtherOption() {
      if (this.componentData.otherOptionId) {
        const sequence = this.componentData.options.length + 1;
        this.componentData.options.push({
          body: this.componentData.otherOptionContentField,
          colorCoding: {
            color: "#fff",
            warningMessage: null
          },
          enabled: true,
          excludeScore: false,
          formattedBody: this.componentData.otherOptionContentField,
          id: this.componentData.otherOptionId,
          isAdvancedScoring: false,
          priority: 0,
          sendNotification: false,
          sequence: sequence
        });
      }
    }
  }
};
</script>
<style scoped>
/deep/ .custom-control-label {
  white-space: normal !important;
  width: 100%;
}
.instruction_title p:first-child {
  font-weight: 600 !important;
}
.instruction_title {
  font-weight: normal;
}
</style>
